import React from 'react';
import { connect } from 'react-redux';

import Loader from '../../components/Loader';

class FundContainer extends React.Component {
  // static propTypes = {
  //   children: PropTypes.element.isRequired,
  //   isLoadingApps: PropTypes.bool.isRequired,
  //   isLoadingStudents: PropTypes.bool.isRequired,
  // };

  render() {
    const { children, isLoadingApps, isLoadingStudents } = this.props;
    if (isLoadingApps || isLoadingStudents) {
      return <Loader />;
    }
    return children;
  }
}

const mapStateToProps = state => ({
  currentSchool: state.settings.current.id,
  isLoadingApps: state.apps.opts.loading && state.apps.opts.didInvalidate,
  isLoadingStudents: state.students.loading && state.students.didInvalidate,

});


export default connect(mapStateToProps)(FundContainer);
